// extracted by mini-css-extract-plugin
export default {"componentWrapper":"SubLayoutDashboard_componentWrapper__XgSHa","menuWrapper":"SubLayoutDashboard_menuWrapper__mZKay"};